module.exports = __webpack_public_path__ + "static/10-26d9a5c4e512f82a0bb0a5dc7edb85af.jpg";